import React, { useEffect, useState } from "react";

import {
  Image,
  View,
  Text,
  StyleSheet,
  FlatList,
  TouchableOpacity,
} from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

import { Ionicons, MaterialCommunityIcons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";

import { getNextInvs, getAllVotes } from "../../api";

//TRADUCCION
import { translations } from "../../components/translations";
import { I18n } from "i18n-js";
const i18n = new I18n(translations);
import { ThemeContext } from "../../components/contexts";

//TEMAS
import { useTheme } from "@react-navigation/native";

//RESPONSIVE
import "@expo/match-media";
import { useMediaQuery } from "react-responsive";

const Item = ({
  id,
  miniatura,
  plazo,
  tipo,
  lugar,
  rentabilidad,
  diasRestantes,
  upvotes,
  downvotes,
}) => {
  const { colors } = useTheme();

  const navigation = useNavigation();

  let bookmarkColor = "";

  if (plazo == "C") {
    bookmarkColor = "#B1F17F";
  } else if (plazo == "M") {
    bookmarkColor = "#D49AF3";
  } else if (plazo == "L") {
    bookmarkColor = "#F1E67F";
  }

  var msiNom = tipo.substring(8);

  const SelectInvs = () => {
    navigation.navigate("IndividualInvs", { id });
  };

  return (
    <View>
      <View style={styles.itemBookmarkContainer}>
        <Ionicons
          name="ios-bookmark"
          size={34}
          style={[styles.itemBookmark, { color: bookmarkColor }]}
        />
        <Text style={styles.itemPlazo}>{plazo}</Text>
      </View>
      <TouchableOpacity
        onPress={SelectInvs}
        style={[
          styles.item,
          styles.buttonShadow,
          {
            backgroundColor: colors.itemContainer,
            shadowColor: colors.shadowColor,
          },
        ]}
      >
        <Image source={{ uri: miniatura }} style={styles.itemImage} />
        <View style={styles.itemTextContainer}>
          <View style={styles.itemDataContainer}>
            <Text style={[styles.itemTipo, { color: colors.textColor }]}>
              {msiNom}
            </Text>
            <Text style={[styles.itemLugar, { color: colors.textColor }]}>
              {lugar}
            </Text>
          </View>
          <View style={styles.numerosContainer}>
            <View style={styles.numerosIndividuales}>
              <Text
                style={[styles.numeroHeader, { color: colors.itemDataHeader }]}
              >
                {i18n.t("diasRestantes")}
              </Text>
              <Text style={[styles.numeroNumero, { color: colors.main }]}>
                {diasRestantes}
              </Text>
            </View>
            <View
              style={[styles.beneficioContainer, { borderColor: colors.main }]}
            >
              <Text
                style={[styles.numeroHeader, { color: colors.itemDataHeader }]}
              >
                {i18n.t("beneficio")}
              </Text>
              <Text style={[styles.numeroNumero, { color: colors.main }]}>
                ≈{rentabilidad}%
              </Text>
            </View>
            <View style={styles.numerosIndividuales}>
              <View style={styles.voteContainer}>
                <MaterialCommunityIcons
                  name="thumb-up"
                  size={20}
                  color={colors.upvote}
                />
                <Text style={[styles.voteNum, { color: colors.upvote }]}>
                  {upvotes}
                </Text>
              </View>
              <View style={styles.voteContainer}>
                <MaterialCommunityIcons
                  name="thumb-down"
                  size={20}
                  color={colors.error}
                />
                <Text
                  style={[
                    styles.voteNum,
                    { color: colors.error, marginBottom: 6 },
                  ]}
                >
                  {downvotes}
                </Text>
              </View>
            </View>
          </View>
        </View>
      </TouchableOpacity>
    </View>
  );
};

const InvNext = ({ navigation }) => {
  const { colors } = useTheme();

  const { language } = React.useContext(ThemeContext);

  i18n.locale = language;
  i18n.enableFallback = false;

  const [shortInvs, setShortInvs] = useState([]);
  const [votings, setVotings] = useState([]);

  const loadEndedInvsByUser = async () => {
    const dataShortInvs = await getNextInvs();
    setShortInvs(dataShortInvs);
  };

  const loadAllVotes = async () => {
    const dataVotes = await getAllVotes();
    setVotings(dataVotes);
  };

  useEffect(() => {
    loadAllVotes();
    loadEndedInvsByUser();
  }, []);

  const renderItem = ({ item }) => {
    let plazo = "";

    if (item.kind == "short") {
      plazo = "C";
    } else if (item.kind == "medium") {
      plazo = "M";
    } else if (item.kind == "long") {
      plazo = "L";
    }

    let upvotes = 0;
    let downvotes = 0;

    let result = votings.filter((obj) => {
      return obj.investment_id == item.id;
    });

    if (result != null) {
      let resultUpvotes = result.find((obj) => {
        return obj.value == 1;
      });
      let resultDownvotes = result.find((obj) => {
        return obj.value == 2;
      });
      if (resultUpvotes != null) {
        upvotes = resultUpvotes.total;
      }
      if (resultDownvotes != null) {
        downvotes = resultDownvotes.total;
      }
    }

    return (
      <Item
        id={item.id}
        miniatura={item.url}
        plazo={plazo}
        tipo={item.name}
        diasRestantes={item.daysleft}
        lugar={item.address}
        rentabilidad={item.initial_profit_percent}
        upvotes={upvotes}
        downvotes={downvotes}
      />
    );
  };

  const isTabletOrMobileDevice = useMediaQuery({
    maxDeviceWidth: 1224,
    // alternatively...
    query: "(max-device-width: 1224px)",
  });

  if (isTabletOrMobileDevice) {
    return (
      <View style={styles.container}>
        <View style={{ marginBottom: 0 }}>
          <Image
            style={styles.loginImage}
            source={require("./../../assets/MSLogo.png")}
          />
        </View>

        <View>
          <Text
            style={{
              fontFamily: "Kodchasan-Regular",
              marginTop: 60,
              textAlign: "center",
              fontSize: 18,
              color: colors.textColor,
            }}
          >
            Parece que estás utilizando un móvil o una tablet.
          </Text>
          <Text
            style={{
              fontFamily: "Kodchasan-Bold",
              marginTop: 60,
              textAlign: "center",
              color: colors.textColor,
            }}
          >
            Por favor utiliza la aplicación oficial.
          </Text>
        </View>
        <View
          style={{
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            overflow: "visible",
          }}
        >
          <TouchableOpacity
            style={{ width: "100%", height: 100, margin: 25 }}
            onPress={() => {
              window.open(
                "https://play.google.com/store/apps/details?id=com.msinvs.msinvs", '_blank'
              );
            }}
          >
            <Image
              style={{ resizeMode: "contain", width: "100%", height: 100 }}
              source={{
                uri: "https://msinvs.com/webtest/images/googleplay_img.png",
              }}
            />
          </TouchableOpacity>
          <TouchableOpacity
            style={{ width: "100%", height: 100 }}
            onPress={() => {
              window.open(
                "https://apps.apple.com/es/app/msinvs/id1565847618", '_blank'
              );
            }}
          >
            <Image
              style={{ resizeMode: "contain", width: "100%", height: 100 }}
              source={{
                uri: "https://msinvs.com/webtest/images/appstore_img.png",
              }}
            />
          </TouchableOpacity>
        </View>

        <View
          style={{
            flex: 1,
            alignItems: "flex-end",
            justifyContent: "flex-end",
          }}
        >
          <Text style={[styles.copyrightText, { color: colors.textColor }]}>
            {i18n.t("copyright")}
          </Text>
        </View>
      </View>
    );
  }

  return (
    <SafeAreaView
      style={[styles.container, { backgroundColor: colors.background }]}
    >
      <View style={{ flex: 1, maxWidth: 1920, width: "100%" }}>
        <View style={styles.inicioWrapper}>
          <View style={styles.backButtonContainer}>
            <TouchableOpacity
              onPress={() => {
                navigation.goBack();
              }}
            >
              <Ionicons
                name="ios-chevron-back"
                size={34}
                color={colors.mainTransparency}
              />
            </TouchableOpacity>
          </View>

          <Text style={[styles.sectionTitle, { color: colors.textColor }]}>
            {i18n.t("proximas")}
          </Text>
          <View style={{ flex: 1 }}>
            <View style={styles.searchResultContainer}>
              <FlatList
                showsVerticalScrollIndicator={false}
                data={shortInvs}
                numColumns={3}
                renderItem={renderItem}
                keyExtractor={(item) => item.id}
              />
            </View>
          </View>
        </View>
      </View>
    </SafeAreaView>
  );
};

export default InvNext;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "flex-start",
    alignItems: "center",
    paddingBottom: 0,
  },
  buttonShadow: {
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 10,
  },

  inicioWrapper: {
    width: "100%",
    justifyContent: "flex-start",
    alignItems: "center",
    flex: 1,
  },

  sectionTitle: {
    fontFamily: "Kodchasan-Bold",
    fontSize: 22,
    textAlign: "center",
    margin: 20,
  },

  //ITEM Y ESO
  item: {
    borderRadius: 15,
    padding: 10,
    marginTop: 8,
    marginBottom: 20,
    marginHorizontal: 10,
    width: 350,
    height: 300,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  itemBookmarkContainer: {
    position: "absolute",
    zIndex: 2,
    right: 5,
    top: 2,
  },

  itemBookmark: {
    position: "absolute",
    zIndex: 2,
    right: 0,
    top: 0,
    textAlign: "center",
  },

  itemPlazo: {
    color: "black",
    fontFamily: "Kodchasan-Bold",

    position: "absolute",
    zIndex: 2,
    right: 11,
    top: 4,
    textAlign: "center",
  },

  itemImage: {
    width: "100%",
    height: "55%",
    borderRadius: 10,
  },

  itemTextContainer: {
    width: "100%",
    flex: 1,
    flexDirection: "column",
  },
  itemDataContainer: {
    flexDirection: "row",
    marginTop: 10,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 10,
  },
  itemTipo: {
    fontFamily: "Roboto-Medium",
    fontSize: 16,
    textAlign: "left",
    width: "60%",
  },
  itemLugar: {
    textAlign: "right",
    fontFamily: "Roboto-Regular",
    fontSize: 12,
    width: "40%",
  },

  numerosContainer: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
  numerosIndividuales: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
  beneficioContainer: {
    justifyContent: "center",
    alignItems: "center",
    borderRightWidth: 1,
    borderLeftWidth: 1,
    flex: 1,
  },
  numeroHeader: {
    fontFamily: "Roboto-Medium",
  },
  numeroNumero: {
    fontFamily: "Kodchasan-Bold",
    fontSize: 24,
  },
  voteContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },
  voteNum: {
    fontFamily: "Kodchasan-Bold",
    fontSize: 16,
    marginLeft: 5,
    minWidth: "10%",
  },

  //BACK BUTTON
  backButtonContainer: {
    width: "auto",
    position: "absolute",
    top: 20,
    left: 25,
  },

  //RESTO
  searchResultContainer: {
    width: "100%",
    height: "100%",
    paddingLeft: 0,
    alignItems: "center",
  },
});
